import React from 'react';
import { useRecoveryStep } from './useRecoveryStep';
import { AuthRecoveryStepView } from './AuthRecoveryStepView';

type AuthRecoveryStepProps = {
    email: string;
    isLoading?: boolean;
    error?: string | null;
    onRecoverySubmit: (email: string) => void;
};

export const AuthRecoveryStep: React.FC<AuthRecoveryStepProps> = ({
    email,
    isLoading,
    error,
    onRecoverySubmit,
}) => {
    const { email: currentEmail, validationError, onEmailChange, onSubmit } =
        useRecoveryStep(onRecoverySubmit, email);

    return (
        <AuthRecoveryStepView
            email={currentEmail}
            error={validationError || error || ''}
            isLoading={isLoading}
            onEmailChange={onEmailChange}
            onSubmit={onSubmit}
        />
    );
};
